import styled from 'styled-components';

export const UlStyled = styled.ul<{ scrollbarColor?: string }>`
  &::-webkit-scrollbar-thumb {
    background: ${(props) => (props?.scrollbarColor ? `${props?.scrollbarColor}!important` : 'var(--color-secondary)')};
  }
`;

export const LiStyled = styled.li<{ bgColor?: string; textColor?: string; openedColor?: string; isActive?: boolean }>`
  color: ${(props) => (props?.isActive ? 'var(--color-secondary) !important' : props?.textColor && `${props?.textColor}!important`)};
  background: ${(props) => (props?.isActive && props?.bgColor ? `${props?.bgColor}!important` : props?.openedColor && `${props?.openedColor}!important`)};
  &:hover {
    background: ${(props) => (props?.bgColor ? `${props?.bgColor}!important` : props?.openedColor && `${props?.openedColor}!important`)};
    color: ${(props) => (props?.textColor ? `${props?.textColor}!important` : 'var(--color-secondary) !important')};
  }
`;
